import { Component, input, ViewEncapsulation } from '@angular/core';
import { LucideDynamicIcon } from '@lucide/angular';

@Component({
  selector: 'app-icon',
  standalone: true,
  imports: [LucideDynamicIcon],
  template: `<svg [lucideIcon]="name()" [size]="size()" [class]="className()"></svg>`,
  encapsulation: ViewEncapsulation.None,
})
export class AppIconComponent {
  readonly name = input.required<string>();
  readonly size = input(18);
  readonly className = input('');
}
